/**
 * @generated SignedSource<<f98ebb188f37ad89ea631f8960a3e9c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ExcludedIpAddressStatus = "ACTIVE" | "INACTIVE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ExcludedIPEditScreenContainer_excludedIpAddress$data = {
  readonly id: string;
  readonly ipAddress: string;
  readonly status: ExcludedIpAddressStatus;
  readonly " $fragmentType": "ExcludedIPEditScreenContainer_excludedIpAddress";
};
export type ExcludedIPEditScreenContainer_excludedIpAddress = ExcludedIPEditScreenContainer_excludedIpAddress$data;
export type ExcludedIPEditScreenContainer_excludedIpAddress$key = {
  readonly " $data"?: ExcludedIPEditScreenContainer_excludedIpAddress$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExcludedIPEditScreenContainer_excludedIpAddress">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExcludedIPEditScreenContainer_excludedIpAddress",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ipAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "ExcludedIpAddress",
  "abstractKey": null
};

(node as any).hash = "2d5d2f7a2b276d213526f05ef08bf1e4";

export default node;
